import { createContext, MutableRefObject } from "react";

type ListRefContextType = {
	inboxListRef?: MutableRefObject<HTMLElement | undefined>;
	archiveListRef?: MutableRefObject<HTMLElement | undefined>;
};
export const ListRefContext = createContext<ListRefContextType>({});
